import React from 'react';

import { Link } from 'gatsby';

import AlifeOrb from '../../images/Alife-Orbs-2.png';
import PlatformOverview from '../../images/home/platformOverview.webp';
import { Button } from '../web';

type HeroProps = {
  onClick?: () => void;
};

const Hero = (props: HeroProps) => {
  return (
    <div className={classNames.container}>
      <div className={classNames.textContainer}>
        <h1 className={classNames.title}>
          Optimize your IVF clinic with artificial&nbsp;intelligence
        </h1>
        <h2 className={classNames.subtitle}>
          Alife&apos;s AI-powered software helps clinics optimize their
          operations to improve outcomes, increase efficiency, and enhance the
          patient experience.
        </h2>
        <div className={classNames.button}>
          <Link to="/platform">
            <Button
              preset="primary"
              text="Explore the platform"
              className="tw-flex-1"
              onClick={props.onClick}
            />
          </Link>
        </div>
      </div>
      <div className={classNames.imgContainer}>
        <div className={classNames.platformContainer}>
          <img
            className={classNames.platformImg}
            src={PlatformOverview}
            alt="Platform overview"
          />
        </div>
        <div className={classNames.orbContainerRel}>
          <div className={classNames.orbContainerAb}>
            <img className={classNames.orb} src={AlifeOrb} alt="Alife orb 2" />
          </div>
        </div>
      </div>
    </div>
  );
};

const classNames = {
  container: [
    'tw-flex',
    'tw-flex-col',
    'tw-overflow-clip',
    'xl:tw-max-w-[1128px]',
  ].join(' '),
  textContainer: [
    'tw-flex',
    'tw-flex-col',
    'tw-my-[32px]',
    'tw-mx-[16px]',
    'tw-items-center',
    'md:tw-my-[40px]',
    'md:tw-mx-[80px]',
    'xl:tw-mt-[80px]',
    'xl:tw-mb-[40px]',
    'xl:tw-mx-0',
  ].join(' '),
  title: ['tw-display2-teodor', 'tw-text-black', 'tw-text-center'].join(' '),
  subtitle: ['tw-h3', 'tw-mt-[24px]', 'tw-text-black', 'tw-text-center'].join(
    ' ',
  ),
  button: [
    'tw-flex',
    'tw-mt-[32px]',
    'md:tw-mt-[40px]',
    'tw-max-w-[354px]',
  ].join(' '),
  imgContainer: ['tw-relative', 'tw-flex', ' tw-flex-1', ' tw-flex-col'].join(
    ' ',
  ),
  platformContainer: [
    'tw-flex',
    'tw-mx-[16px]',
    'md:tw-mx-[100px]',
    'tw-max-h-[350px]',
    'xl:tw-max-h-[450px]',
  ].join(' '),
  platformImg: ['tw-flex', 'tw-object-contain'].join(' '),
  orbContainerRel: [
    'tw-absolute',
    'tw-h-[100%]',
    'tw-w-[100%]',
    'tw-left-[50%]',
    'tw-top-[35%]',
  ].join(' '),
  orbContainerAb: ['tw-absolute', 'tw-flex', 'tw-z-[-100]'].join(' '),
  orb: [
    'tw-object-fill',
    'tw-w-[1086px]',
    'md:tw-w-[1308px]',
    'tw-ml-[-50%]',
    'tw-max-w-none',
    'tw-rotate-[-115deg]',
  ].join(' '),
};

export { Hero };
